import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledSubHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 8px;
    background-color: var(--color-grey-400);
`;

export const StyledSubHeaderContainer = styled.div`
    width: 100%;
    max-width: var(--max-page-width);
    box-sizing: border-box;
    padding: 8px 15px;
    margin: 0 auto;
    background-color: var(--color-grey-400);

    .filterRow {
        margin-top: 24px;
        margin-bottom: 8px;
        &:empty {
            display: none;
        }

        align-items: flex-start;
        gap: 16px;
        flex-flow: row wrap;
        @media ${breakpoints.xs} {
            gap: 8px;
        }

        .spacer {
            flex: 1;
        }
    }
`;

export const StyledPaginatedListOptionItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .paginatedListOptionIcon {
        width: 40px;
        min-width: 40px !important;
        height: 40px;
        background: var(--color-white);
        border: 1px solid var(--color-grey-600);
        border-radius: var(--radius-10);
        padding: initial;
        box-shadow: none;

        svg path {
            fill: var(--color-secondary);
        }
        &:focus {
            background-color: var(--color-grey-400);
        }
        &:hover {
            box-shadow: none;
        }
    }
    .paginatedListOptionLabel {
        margin-top: 8px;
        font-size: var(--size-8);
        color: #939393;
    }
`;
